// ----------------------------------------------------------------------

const account = {
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
